import Button from "@material-ui/core/Button";
import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import PageHeader from "@saleor/components/PageHeader";
import { sectionNames } from "@saleor/intl";
import { MenuListUrlSortField } from "@saleor/navigation/urls";
import { ListActions, PageListProps, SortPage } from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import {
  MenuList_menus_edges_node,
  MenuList_shop_navigation
} from "../../types/MenuList";
import MenuList from "../MenuList";

export interface MenuListPageProps
  extends PageListProps,
    ListActions,
    SortPage<MenuListUrlSortField> {
  menus: MenuList_menus_edges_node[];
  homemenus: MenuList_shop_navigation;
  onBack: () => void;
  onMain: (id: string) => void;
  onNewMain: (id: string) => void;
  onSecondary: (id: string) => void;
  onFooter: (id: string) => void;
  onDelete: (id: string) => void;
  toatlCount: number;
}

const MenuListPage: React.FC<MenuListPageProps> = ({
  onAdd,
  onBack,
  toatlCount,
  ...listProps
}) => {
  const intl = useIntl();
  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.configuration)}
      </AppHeader>
      <PageHeader
        title={
          intl.formatMessage(sectionNames.navigation) + "(" + toatlCount + ")"
        }
      >
        <Button color="primary" variant="contained" onClick={onAdd}>
          <FormattedMessage
            defaultMessage="Create Menu"
            description="button"
            id="menuListPageAddMenu"
          />
        </Button>
      </PageHeader>
      <MenuList {...listProps} />
    </Container>
  );
};
MenuListPage.displayName = "MenuListPage";
export default MenuListPage;
